import useSWR from 'swr'
import {
  fetchUserInfo,
  fetchOrgUser,
  fetchUserPower,
} from '@vt/apis/lib-ex/v2/users'
import { useParams } from 'react-router-dom'

export const useUserInfoSWR = (token, isNormal, searchParamAppId) => {
  const { appId } = useParams()
  const finalAppId = appId || searchParamAppId

  const { data, mutate, error } = useSWR(
    token ? ['fetch-user-info', token] : null,
    {
      fetcher: (params) => {
        return isNormal ? fetchOrgUser(finalAppId) : fetchUserInfo(params)
      },
    }
  )

  return {
    userInfo: data || null,
    userInfoMutate: mutate,
    isUserLoading: !error && !data,
    fetchUserInfoError: error,
  }
}

export const useUserNavsSWR = (token, appId, tpl) => {
  const { data, mutate, error } = useSWR(
    token ? ['fetch-user-navs', token] : null,
    {
      fetcher: () => {
        return fetchUserPower(appId, tpl)
      },
    }
  )

  return {
    userNavs: (data && data.value) || [],
    userNavsMutate: mutate,
    isUserNavsLoading: !error && !data,
    fetchUserNavsError: error,
  }
}
